export default "__VITE_ASSET__3f99725a__"